import { createImmerReducer } from "utils/ReducerUtils";
import type { ReduxAction } from "ee/constants/ReduxActionConstants";
import { ReduxActionTypes } from "ee/constants/ReduxActionConstants";

import type { FlattenedDSL } from "@shared/dsl";
import { flattenDSL } from "@shared/dsl";
import type { WidgetProps } from "widgets/BaseWidget";

export interface CurrentPageDraftDataState {
  data:
    | {
        page?: any;
        id?: string;
        userPermissions?: string[];
        applicationId?: string;
        userId?: string;
        pageId?: string;
      }
    | null
    | undefined;
}

const initialState: CurrentPageDraftDataState = {
  data: undefined,
};

const currentPageDraftDataReducer = createImmerReducer(initialState, {
  // Reducer to clear all pageWidgets before finishing creating
  // a new application

  [ReduxActionTypes.GET_PAGE_DRAFT_SUCCESS]: (
    state: CurrentPageDraftDataState,
    action: ReduxAction<CurrentPageDraftDataState>,
  ) => {
    console.log("asdasd", action, state);
    state.data = action.payload.data;
  },
});

export default currentPageDraftDataReducer;
